import parseToken, { AccessToken, RefreshToken } from '@/auth/token'
import { defineStore } from 'pinia'

export declare interface TokenData {
  accessTokenRaw?: string,
  refreshTokenRaw?: string
}

export const useTokenStore = defineStore('tokenStore', {
  state: (): TokenData => ({
    accessTokenRaw: '',
    refreshTokenRaw: ''
  }),
  actions: {
    setToken (tokenData: TokenData ): TokenData{
      if (tokenData.accessTokenRaw) {
        this.accessTokenRaw = tokenData.accessTokenRaw
      }
      if (tokenData.refreshTokenRaw) {
        this.refreshTokenRaw = tokenData.refreshTokenRaw
      }
      return tokenData
    },
    getAccessToken (): AccessToken|undefined{
      if (this.accessTokenRaw) {
        return parseToken<AccessToken>(this.accessTokenRaw)
      }
      return undefined
    },
    getRefreshToken (): RefreshToken | undefined{
      if (this.refreshTokenRaw) {
        return parseToken<RefreshToken>(this.refreshTokenRaw)
      }
      return undefined
    }
  }
})
